import { BaseAction, } from "./BaseAction";
export class FunctionAction extends BaseAction {
    fn;
    constructor(fn, options = {}) {
        super(options);
        this.fn = fn;
    }
    triggerImplementation(options) {
        return this.fn(...(options.args ?? []));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVuY3Rpb25BY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2FjdGlvbnMvRnVuY3Rpb25BY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLFVBQVUsR0FLWCxNQUFNLGNBQWMsQ0FBQztBQU10QixNQUFNLE9BQU8sY0FBZSxTQUFRLFVBQVU7SUFDM0IsRUFBRSxDQUFtQjtJQUV0QyxZQUFtQixFQUFvQixFQUFFLFVBQXlCLEVBQUU7UUFDbEUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ2YsSUFBSSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUM7SUFDZixDQUFDO0lBRVMscUJBQXFCLENBQzdCLE9BQTZCO1FBRTdCLE9BQU8sSUFBSSxDQUFDLEVBQUUsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLElBQUksSUFBSSxFQUFFLENBQUMsQ0FBQyxDQUFDO0lBQzFDLENBQUM7Q0FDRiJ9